import { EHeadingStyleVariant, ETextStyleVariant, Heading, Text } from '@outdoorsyco/bonfire';
import React from 'react';
import { FormattedMessage } from 'react-intl';

import MaxWidth from '@/components/common/layout/MaxWidth';
import { IAddress } from '@/components/route/campground/campgroundTypes';
import ClampModal from '@/components/route/listing/ClampModal/ClampModal';
import { ICoordinates } from '@/utility/commonDataTypes';

import { LocationMap } from '../LocationMap/LocationMap';

type TAboutProps = {
  title: string;
  description: string;
  geopoint: ICoordinates;
  address: IAddress;
};

export const About = ({ title, description, geopoint, address }: TAboutProps) => {
  return (
    <section className="py-8 md:py-12">
      <MaxWidth className="mx-auto">
        <div className="flex flex-col items-center md:flex-row md:gap-0 gap-8">
          <div className="flex flex-col flex-1 gap-4">
            <Heading variant={EHeadingStyleVariant.H4} className="font-normal" component="h2">
              <FormattedMessage
                defaultMessage={`Why folks are staying at {campground}`}
                id="uvshuW"
                values={{ campground: title }}
              />
            </Heading>

            <ClampModal lineCount={6} modalTitle={title} ellipsis>
              <Text variant={ETextStyleVariant.LargeRegular} className="my-2">
                {description}
              </Text>
            </ClampModal>
          </div>

          <LocationMap location={geopoint} address={address} />
        </div>
      </MaxWidth>
    </section>
  );
};
